// /pdf/sections/overview.js
import { addGauges, addMetricRow } from "../helpers";

export function renderOverview(doc, data, icons, donutBase64, startY = 30) {
    let y = startY;
    doc.setTextColor(40, 40, 100);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("1. Overview", 14, y);

    y += 15;

    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("SDG Indicator for Sanitation", 14, y);
    y += 10;

    const sdgIndicators = data["SDG Indicators for Sanitation"] || [];
    const cards = sdgIndicators.map(i => ({
        label: i.indicator,
        value: i.value
    }));
     //addCards(doc, cards, y);
    addGauges(doc, cards, y)
    
    y += 40;

    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("Basic Information", 14, y);
    if (donutBase64) {
        const pageWidth = doc.internal.pageSize.getWidth(); // e.g., 210 for A4
        const imgWidth = 120;  // your desired width
        const imgHeight = 70;  // your desired height
        const x = (pageWidth - imgWidth) / 2; // center horizontally

        doc.addImage(donutBase64, "PNG", x, y, imgWidth, imgHeight);
    }

    y += 80;

    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("Sanitation Profile", 14, y);
    y += 10;
    const sanitationProfile = data["Sanitation Profile"] || [];

    let fsGeneration = sanitationProfile.find(i => i.indicator === "FS Generation")?.value || "";
    let fsCollection = sanitationProfile.find(i => i.indicator === "FS Collection")?.value || "";
    let fsTreatment = sanitationProfile.find(i => i.indicator === "FS Treatment")?.value || "";
    let fstp = sanitationProfile.find(i => i.indicator === "FSTP")?.value || "";

    const SanitationMetrics = [
        { icon: icons.fsGen, label: "FS Generation", value: fsGeneration },
        { icon: icons.fsCol, label: "FS Collection", value: fsCollection },
        { icon: icons.fsTrt, label: "FS Treatment", value: fsTreatment },
        { icon: icons.fsTP, label: "FSTP", value: fstp },
    ];
    addMetricRow(doc, SanitationMetrics, y);
    y += 25;

    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("SWM Summary", 14, y);
    y += 10;
    const swmSummary = data["SWM Summary"] || [];

    let swGeneration = swmSummary.find(i => i.indicator === "SW Generation")?.value || "";
    let swCollection = swmSummary.find(i => i.indicator === "SW Collection")?.value || "";
    let swTreatment = swmSummary.find(i => i.indicator === "SW Treatment")?.value || "";
    let swtp = swmSummary.find(i => i.indicator === "SWTP")?.value || "";

    const swmMetrics = [
        { icon: icons.swGen, label: "SW Generation", value: swGeneration },
        { icon: icons.swCol, label: "SW Collection", value: swCollection },
        { icon: icons.swTrt, label: "SW Treatment", value: swTreatment },
        { icon: icons.swTP, label: "SWTP", value: swtp },
    ];
    addMetricRow(doc, swmMetrics, y);
    y += 20;

    return y;
}